import React from 'react';
import * as Sentry from '@sentry/react';

// import cacheService from '../services/cache';

const useCache = (key, initialValue) => {
  const [storedValue, setStoredValue] = React.useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  };

  return [storedValue, setValue];
};

export default useCache;
